module.exports = __webpack_public_path__ + "img/flight-confirmed.de707804.svg";